import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAppContext } from './AppContext';
import { customStorage, getPayloadData, isInRole, isTokenValid } from '../services/UtilityService';
import { ROUTE_NOT_ALLOWED } from '../constants/routeConstants';
import { TOKEN_SESSION_KEY } from '../constants/commonConstants';

const AuthRoleBaseRoute = ({ element, allowedRoles, mainMenu}) => {
  const { sessionTimeoutLogout, logout, setMainMenu } = useAppContext();
  const token =  customStorage.getItem(TOKEN_SESSION_KEY);
  const user = getPayloadData(token);
  const navigate = useNavigate();

  useEffect(()=> {
    // if(token && !isTokenValid(token)){
    //   // sessionTimeoutLogout();
    //   // return;
    // }
    
    if(!token || !user){
      logout();
      return;
    }
    setMainMenu(mainMenu || null)
  }, [navigate]);

  if (!!user && allowedRoles && allowedRoles.length > 0 && !isInRole(allowedRoles, user.role)) {
    return <Navigate to={ROUTE_NOT_ALLOWED} />;
  }

  return element;
};

export default AuthRoleBaseRoute; 
